// extracted by mini-css-extract-plugin
export default {"imageItem":"ImagePreview_imageItem__p7C9H","link":"ImagePreview_link__NVZZ8"};